import * as React from "react";
import DetailGrid, { DetailGridItem } from "common/components/controls/DetailGrid";
import DetailGroup from "common/components/controls/DetailGroup";
import { formatDate } from "common/utils/FmtDate";
import { Prestup } from "common/api/Evidence/Clenove/Prestupy";
import PrestupyUtils from "common/utils/PrestupyUtils";

interface SpravniPoplatekProps {
    prestup: Prestup;
    je_to_clen: boolean;
    prest_do_divize: boolean;
    je_to_nov_klub: boolean;
}
class SpravniPoplatek extends React.PureComponent<SpravniPoplatekProps>{

    render() {

        const { prestup, je_to_clen, prest_do_divize, je_to_nov_klub } = this.props;

        const itemsPlatba: DetailGridItem[] = [
            { label: 'Částka', content: prestup.popl_castka + ',- Kč' },
            { label: 'Zaplacen dne', content: formatDate(prestup.popl_dat_platby) },
        ];

        const itemsDispozice: DetailGridItem[] = [
            { label: 'Částka', content: prestup.popl_castka + ',- Kč' },
            { label: 'Číslo účtu', content: prestup.popl_cis_uctu },
            { label: 'Variabilní symbol', content: prestup.popl_var_sym },
            { label: 'Specifický symbol', content: prestup.popl_spec_sym },
        ];

        if ((je_to_clen && prest_do_divize) || (je_to_nov_klub && !prest_do_divize)) {
            if (prestup.stav >= PrestupyUtils.Stav_ZaplaceniPopl) {
                return <DetailGroup title="Správní poplatek za podání přestupu">
                    {prestup.stav === PrestupyUtils.Stav_ZaplaceniPopl
                        ? <DetailGrid items={itemsDispozice} labelXS={4} />
                        : <DetailGrid items={itemsPlatba} labelXS={4} />
                    }
                </DetailGroup>;
            }
        }

        return null;
    }
}

export default SpravniPoplatek;
